export const UPDATE_RULE = 'FEEDFILTER/UPDATE_RULE';
export const ADD_CONJUNCTION = 'FEEDFILTER/ADD_CONJUNCTION';
export const ADD_RULE = 'FEEDFILTER/ADD_RULE';
export const REMOVE_NODE = 'FEEDFILTER/REMOVE_NODE';
export const SET_RULES = 'FEEDFILTER/SET_RULES';